// C2wLayout.jsx
import { Outlet, useLocation } from 'react-router';
import { useState, useEffect } from 'react';
import C2wSuperxHome from '../superxIndex';
import { SUPERX } from '../../../_utils/Routes';

const C2wSuperxLayout = () => {
  const location = useLocation();
  const [showSuperxHome, setShowSuperxHome] = useState(location.pathname === SUPERX);

  useEffect(() => {
    setShowSuperxHome(location.pathname === SUPERX);
  }, [location]);

  return (
    <>
      {/* Home stays mounted; we toggle visibility */}
      <div style={{ display: showSuperxHome ? 'block' : 'none' }}>
        < C2wSuperxHome />
      </div>

      {/* Nested route component like CourseDetails */}
      <Outlet />
    </>
  );
};

export default C2wSuperxLayout;
